// extracted by mini-css-extract-plugin
module.exports = {"body":"PortfolioModal__body___2eGrr"};